import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=f223999a&scoped=true&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"
import style0 from "./Activate.vue?vue&type=style&index=0&id=f223999a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223999a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/user-activation/Activate.vue
// module id = 940
// module chunks = 0